import { useEffect, useState } from "react";
import { API_URL } from "../../../../../constants";
import { useAuth } from "../../../../../provider";
import axios from "axios";
import { Card, Typography, Grid, Box, CircularProgress, Tooltip, IconButton} from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import CustomDialogSmall from "../../../../../components/Dialog/DiaCompSmall";
//import BioAgeGauge from './BioAgeGauge'
import { useTheme } from "@mui/material";

export default function BioAgeSubCard() {

const theme = useTheme();
const { state } = useAuth();

const url_age = `${API_URL}/phenoages/`
  
const [bioAgeData, setBioAgeData] = useState([]);
const [loading, setLoading] = useState(true);
const [error, setError] = useState(null);

const [dialogOpen, setDialogOpen] = useState(false);
const handleOpen = () => {setDialogOpen(true);};
const handleClose = () => {setDialogOpen(false);};

useEffect(() => {
    const fetchBioAge = async () => {
      try {
        const response = await axios.get(url_age);
        if (response.data && response.data.length > 0) {
        // Sort by date descending and pick the most recent
        const mostRecent = response.data.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        )[0];

        setBioAgeData(mostRecent);
      }
      } catch (err) {
        setError(err.response?.data?.detail || "Failed to load bio age data");
      } finally {
        setLoading(false);
      }
    };

    fetchBioAge();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box mt={4}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

return(
  <>
 <Grid container spacing={1} sx={{maxWidth: 400, mb: 16, display: "flex", justifyContent: "center", alignItems: "center",}}>
      
      {/* ================= BIOAGE HEADS UP DISPLAY ================= */}
      <Grid size={{ xs: 12 }} sx={{ mt: 2, mb:4, maxWidth: 1000, display: "flex", justifyContent: "center", alignItems: "center",}}>
   <Card 
            variant="outlined"
            sx={{
            width: '100%',
            borderRadius: 2,
            boxShadow: 'none',
            borderColor: theme.palette.mode === 'light' ? 'grey.C400' : 'greydark.C400',
            backgroundColor: theme.palette.mode === 'light' ? 'grey.C100' : 'greydark.C970',
            }}
            >
        {bioAgeData && ( 
        <Grid container sx={{width: '100%', p:1.3, flex: 1, minWidth: 0}}>
               <Grid size={6} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>

                  <Grid container sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', }}>
                        <Grid size={12} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'  }}>
                                <Typography variant="h5" sx={{ display: 'block', fontWeight: 400, letterSpacing: 0.3 }}>
                                BIOLOGICAL AGE
                                </Typography>
                        </Grid>
            
                    <Grid size={12} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                                 Proteomic Clock
                            </Typography>
                    </Grid>

                    <Grid  size={2} sx={{ display: "flex", justifyContent: 'flex-start', alignItems: "center" }}>
                      <Tooltip title="Info" placement="left">
                          <IconButton size="small" onClick={() => handleOpen()} aria-label="More information" sx={{ '&:hover': {transform: 'scale(1.2)'}, }} >
                              <InfoOutlineIcon size="small" sx={{color: 'greydark.C200', '&:hover': { transform: 'scale(1.3)'}, }}/>
                          </IconButton>   
                      </Tooltip>
                    </Grid>

                  </Grid>
               </Grid>

            <Grid size={6} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', }}>
              
                <Grid container sx={{width: '100%', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', }}>
                
                <Grid size={11} sx={{ display: 'flex', justifyContent:'flex-end', alignItems: 'center', gap: 1 }}>
                  
                  <Typography variant="number" component="div"
                    sx={{ fontWeight: 400, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {Number(bioAgeData.bioage).toFixed(1)}  <Typography variant="subtitle2" component="span"> years old </Typography>
                  </Typography>
                  
                  {/* severity indicator dot */}
                  <Grid size={1}
                    sx={{
                      width: 14,
                      height: 14,
                      borderRadius: '50%',
                      backgroundColor: Number(bioAgeData.agediff) < 0 ? 'traffic.green' : 'traffic.red',
                      boxShadow: `0 0 0 4px ${theme.palette.traffic.green}22`, // subtle halo
                      ml: 1,
                    }}
                  />
                </Grid>
                 </Grid>
              </Grid>
               <Grid size={12} sx={{mr:2, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', }}>
                           {Number(bioAgeData.agediff) < 0 ? (
                            <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                              Versus real age of {state.user.age} you are{" "}
                              {Math.abs(Number(bioAgeData.agediff)).toFixed(1)} years younger
                            </Typography>
                          ) : (
                            <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                              Versus real age of {state.user.age} you are{" "}
                              {Number(bioAgeData.agediff).toFixed(1)} years older
                            </Typography>
                          )}
                </Grid>
                  <Grid size={12} sx={{mr:2, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                             Your Rate of Aging is{" "}
                                {(
                                  Math.abs(Number(bioAgeData.bioage)) / Math.abs(Number(state.user.age))
                                ).toFixed(1)}
                            </Typography>
                </Grid>
                 <Grid size={12} sx={{mr:2, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                              Your mortality risk in the next 10 years is {bioAgeData.mortrisk} %
                            </Typography>
                </Grid>

  </Grid>
  )}

</Card>
</Grid>
</Grid>

 <CustomDialogSmall open={dialogOpen} onClose={handleClose}
          title="What does the test result mean?"
          content = {
            <Grid container>
              <Grid size={12} sx={{display:'flex', justifyContent:'center', alignItems:'center'}}> 
                {bioAgeData?.ai_recommendation || "No recommendation available"}
              </Grid>
            </Grid>
            }
        />


</>
    )
}

/*
  <Typography variant="subtitle2" sx={{ fontWeight: 300 }}>
                     {diffage}&nbsp;  years difference <br /> to chronological age 
                  </Typography>
*/